import { getAuthConfig } from '../services/configService';

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 * 
 * Auth config values are loaded from config.json
 */
export const getMsalConfig = () => {
    const authConfig = getAuthConfig();
    return {
        auth: {
            clientId: authConfig.clientId,
            authority: authConfig.authority,
            redirectUri: authConfig.redirectUri,
            postLogoutRedirectUri: authConfig.postLogoutRedirectUri,
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: 'sessionStorage',
            storeAuthStateInCookie: false,
        }
    };
};

 /**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
 export const loginRequest = {
     scopes: ["User.Read"],
     prompt: "select_account"
 };